import { GUIDELINE_TIER_LABELS, type GuidelineTier } from '@/entities/media-guideline';

/** Badge variant per tier, so every surface that shows one agrees on its colour. */
export const TIER_VARIANT: Record<GuidelineTier, 'destructive' | 'warning' | 'secondary'> = {
  block: 'destructive',
  warn: 'warning',
  advise: 'secondary',
};

/**
 * A platform rule's severity as the tier the same thing is called on a guideline.
 *
 * Two names for one idea: the rule set inherited the parser's severities and the
 * guidelines inherited the governance tiers. They sit one above the other on the same
 * page, so the reader has to be told once — "Block" — rather than "Blocks" here and
 * "Block" there, in two different colours.
 */
const TIER_BY_SEVERITY: Record<'error' | 'warning' | 'advice', GuidelineTier> = {
  error: 'block',
  warning: 'warn',
  advice: 'advise',
};

export function tierOfSeverity(severity: 'error' | 'warning' | 'advice'): GuidelineTier {
  return TIER_BY_SEVERITY[severity];
}

export function severityLabel(severity: 'error' | 'warning' | 'advice'): string {
  return GUIDELINE_TIER_LABELS[tierOfSeverity(severity)];
}
